import React, { useState, useEffect } from "react";
import {Link } from 'react-router-dom'
import axiosInstance from "../../../services/api";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../Commons/Loader';
import Select from "react-select";
function AddUser() {
    const history = useHistory();
   // const rolesFromLocalStorage = JSON.parse(localStorage.getItem('role'));
    const [userFetchData, setUserFetchData] = useState([]);
    const [propertyId, setPropertyId] = useState([]);
    const [roleId, setRoleId] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemsRole, setSelectedItemsRole] = useState([]);
    const [errors, setErrors] = useState({});
    const [isCheckedEnable, setIsCheckedEnable] = useState(true);
    const [isChecked2FA, setIsChecked2FA] = useState(true);
    const [userTypes, setUserTypes] = useState([]);
    const [userGroup, setUserGroup] = useState([]);
    const [userHotel, setUserHotel] = useState([]);
    const [userRole, setUserRole] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
  

    const fetchUserData = async () => {
        try {
            const response = await axiosInstance.get('user/add-edit-user'); // Fetch data
            setUserFetchData(response.data.data);  // Store full API data
            setUserTypes(response.data.data.userTypes || []); // Update userTypes
            setUserGroup(response.data.data.groupedHotelsBean.groups || [])
            setUserRole(response.data?.data?.roles || [])
            //localStorage.setItem('role', JSON.stringify(response.data.data.roles));
    
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
          }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    useEffect(() => {
        if (userGroup.length > 0) {
            const allHotels = [];
            // Loop through userGroup and log each group
            userGroup.forEach((group) => {
                // Add the group's hotels to the array
                allHotels.push(...group.hotels); // Using spread to merge arrays
            });
            //setUserHotel([allHotels]);
            setUserHotel([]);
        }

    }, [userTypes,userGroup, userRole]);
    const [formData, setFormData] = useState({
        id:null,
        userType: "",
        email: "",
        password: "",
        confirmPassword: "",
        name: "",
        designation: "",
        selectGroup:""
    });
    const userTypeCheck = formData.userType;
    const hotelOptions = userHotel.map(hotel => ({
        id: hotel.id,
        value: hotel.id,  // Use hotelName as value
        label: hotel.hotelName   // Optionally, you can also use hotelName as the label
    }));
    console.log(userTypeCheck,"hotelOptions")
    // const roleOptions = userRole.map(role => ({
    //     id: role.id,
    //     value: role.name,  // Use hotelName as value
    //     label: role.name   // Optionally, you can also use hotelName as the label
    // }));
  const validate = () => {
    let tempErrors = {};
    let isValid = true;
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!formData.userType) {
      tempErrors.userType = "Please select user type";
      isValid = false;
    }

    if (!formData.email) {
      tempErrors.email = "Please type email";
      isValid = false;
    } else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      tempErrors.email = "Please type a valid email";
      isValid = false;
    }

    if (!formData.password) {

    }else if (!passwordPattern.test(formData.password)) {
        tempErrors.password = "Password must be at least 8 characters, include uppercase, lowercase, number, special character";
        isValid = false;
    }

    if (formData.password !== formData.confirmPassword) {
        tempErrors.confirmPassword = "Password and confirm password do not match";
        isValid = false;
    } 

    if (!formData.name) {
      tempErrors.name = "Please type name";
      isValid = false;
    }
    if (userTypeCheck === "USER") {
        if (!formData.selectGroup) {
            tempErrors.selectGroup = "Please select group";
            isValid = false;
        }
    }
    if (userTypeCheck === "USER") {
        if (selectedItems.length === 0) {
            tempErrors.selectedItems = "Please select at least one item";
            isValid = false;
        }
    }
    if (userTypeCheck === "ADMIN") {
        if (selectedItemsRole.length === 0) {
            tempErrors.selectedItemsRole = "Please select at least one item";
            isValid = false;
        }
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });

     if (name === "selectGroup") {
        if (value === "all-hotel") {
            const extractHotels = userGroup.map(group => group.hotels).flat();
            // const hotelNames = extractHotels.map(hotel => hotel.hotelName);
            setUserHotel(extractHotels);  // Assuming hotelOptions is the array with all hotels
        } else {
            // Filter hotels based on selected group
            const filteredHotels = userGroup.find(group => group.name === value)?.hotels || [];
            console.log(filteredHotels,"filteredHotelsfilteredHotelsfilteredHotels")
            setUserHotel(filteredHotels);
        }
        // userHotel
        setSelectedItems([]); // Reset selection when group changes
    }
  };

  const handleChangeProperty = (newSelected) => {
    console.log(newSelected,"newSelected")
    const selectedIds = newSelected.map(optionValue => {
        const selectedOption = hotelOptions.find(option => option.value === optionValue);
        return selectedOption ? parseInt(selectedOption.id, 10) : null;
    });
    console.log(selectedIds,"selectedIds")
    setSelectedItems(newSelected);  // Store the ids instead of values
    // Clear error if no items are selected
    if (selectedIds.length === 0) {
        setErrors({ ...errors, selectedItems: "" });
    }
    setPropertyId(selectedIds)

  };
  const handleChangePropertyMob = (selectedOptions) => {
        setSelectedItems(selectedOptions.map(opt => opt.value));
        const selectedPropertyIdsMob = selectedOptions.map(opt => opt.value);
        setPropertyId(selectedPropertyIdsMob);
  };

  const handleChangeRole = (newSelectedRole) => {
    if (userRole.length === 0) {
        console.error("Role not loaded yet.");
        return;
    }
    const selectedIdsRole = newSelectedRole.map(optionValue => {
        const selectedOptionRole = userRole.find(option => option.value === optionValue);
        return selectedOptionRole ? parseInt(selectedOptionRole.id, 10) : null;
    });
    setSelectedItemsRole(newSelectedRole);
    setRoleId(selectedIdsRole)
  };
  
  const handleChangeRoleMob = (selectedOptions) => {
    setSelectedItemsRole(selectedOptions.map(opt => opt.value));
    const selectedRoleIdsMob = selectedOptions.map(opt => opt.value);
    setRoleId(selectedRoleIdsMob);
  };
  
  const handleChangeEnableToggle = () => {
    setIsCheckedEnable(!isCheckedEnable);

  };
  const handleChange2FAToggle = () => {
    setIsChecked2FA(!isChecked2FA);
  };
  const handleSubmit = async (e) => {
    toast.dismiss();
    e.preventDefault();
   
    if (validate()) {
        setLoading(true);
    try {
        const { confirmPassword, selectGroup, ...filteredFormData } = formData;
        const response = await axiosInstance.post('user/save', {
            ...filteredFormData,
            hotelIdList : propertyId,
            roleIdList : roleId,
            tfaEnabled : isChecked2FA,
            enbaled : isCheckedEnable
            // selectedItems,
            // selectedItemsRole
        });
        if (response.status === 200) {
            if(response.data.status.code===200) {
                toast.success(response.data.status.message);
                setTimeout(() => {
                    history.push('/all-users'); 
                }, 2000);
            }else{
                toast.error(response.data.status.message);
            }
        }
            
        } catch (error) {
        console.error('Error validating OTP:', error);
        }finally {
            setLoading(false);
          }
    }
  };
  const handleCancel = (e) => {
    e.preventDefault();
    setFormData({
        userType: "",
        email: "",
        password: "",
        confirmPassword: "",
        name: "",
        designation: "",
        selectGroup:""
    });
    setSelectedItems([]);
    setSelectedItemsRole([]);

    // Reset toggle states if necessary
    setIsCheckedEnable(true);
    setIsChecked2FA(true);

    // Optionally, reset errors if required
    // setErrors({});
  }
    return (
        <>
            {loading && <Loader />} 
            <div className="content-header">
                <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6 title-mob">
                    <h1 className="m-0">Add User</h1>
                    <Link className="btn btn-primary submit-btn" to="/all-users">All Users</Link>
                    </div>{/* /.col */}
                    <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Add User</li>
                    </ol>
                    </div>{/* /.col */}
                </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <form className="row">
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                            <label>User Type <span>*</span></label>
                            <select className="select-fld" name="userType" value={formData.userType} onChange={handleChange}>
                                <option value="">Select User Type</option>
                    
                                {userTypes.length > 0 && userTypes.map((item, index) => (
                                    <option key={index} value={item}>{item}</option>
                                ))}
                    
                            </select>
                            {errors.userType && <span className="error">{errors.userType}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                            <label>Email <span>*</span></label>
                            <input type="text" className="input-fld" name="email" value={formData.email} onChange={handleChange}/>
                            {errors.email && <span className="error">{errors.email}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group pos-rel-user">
                            <label>Password</label>
                            <sup className="password-type">(Password must be at least 8 characters, include uppercase, lowercase, number, and special character)</sup>
                            <input type={showPassword ? "text" : "password"}  className="input-fld" name="password" value={formData.password} onChange={handleChange} autoComplete="off"/>
                            <a className='see-password' onClick={() => setShowPassword((prev) => !prev)}> {showPassword ? <i className="nav-icon fas fa-eye-slash" /> : <i className="nav-icon fas fa-eye" />} </a>
                            {errors.password && <span className="error">{errors.password}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                            <label>Confirm Password </label>
                            <sup className="password-type">&nbsp;</sup>
                            <input type="password" className="input-fld" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} />
                            {errors.confirmPassword && <span className="error">{errors.confirmPassword}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                            <label>Name <span>*</span></label>
                            <input type="text" className="input-fld" name="name" value={formData.name} onChange={handleChange} />
                            {errors.name && <span className="error">{errors.name}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group">
                            <label>Designation</label>
                            <input type="text" className="input-fld" name="designation" value={formData.designation} onChange={handleChange} />
                            </div>
                        </div>
                        { userTypeCheck ==="USER" && (
                        <div className="col-12">
                                <div className="form-group">
                                    <label>Group <span>*</span></label>
                                    <select className="select-fld" name="selectGroup"  value={formData.selectGroup} onChange={handleChange}>
                                        <option value="">Select Group</option>
                                        <option value="all-hotel">All Hotels</option>
                                        {/* {userGroup.length > 0 && userGroup.map((item, index) => (
                                            <option key={index} value={item.name}>{item.name}</option>
                                        ))} */}
                                        {userGroup?.length > 0 && userGroup.map((item, index) => (
                                            <option key={index} value={item.name}>{item.displayName}</option>
                                        ))}
                                        {/* <option value="ITC Hotels">ITC Hotels</option>
                                        <option value="Taj Hotels">Taj Hotels</option> */}
                                    </select>
                                    {errors.selectGroup && <span className="error">{errors.selectGroup}</span>}
                                </div>
                            </div>
                        )}
                        {userTypeCheck === "USER" &&(
                        <div className="col-lg-12 col-12">
                            <div className="form-group">
                                <label>Property <span>*</span></label>
                                <DualListBox
                                    options={hotelOptions}
                                    selected={selectedItems}
                                    onChange={handleChangeProperty}
                                    className="hideMob"
                                />
                                <Select
                                    options={hotelOptions.map(p => ({ value: p.id, label: p.label }))}
                                    isMulti
                                    onChange={handleChangePropertyMob}
                                    className="hideweb"
                                />
                                {errors.selectedItems && <span className="error">{errors.selectedItems}</span>}
                            </div>
                        </div>
                        )}
                        {userTypeCheck === "ADMIN" && (
                        <div className="col-lg-12 col-12">
                            <div className="form-group">
                                <label>Role <span>*</span></label>
                                {loading ? (
                                <p>Loading permissions...</p>
                                ) : (
                                <DualListBox
                                    options={userRole}
                                    selected={selectedItemsRole}
                                    onChange={handleChangeRole}
                                    className="hideMob"
                                />
                                )}
                                <Select
                                    options={userRole.map(p => ({ value: p.id, label: p.label }))}
                                    isMulti
                                    onChange={handleChangeRoleMob}
                                    className="hideweb"
                                />
                                {errors.selectedItemsRole && <span className="error">{errors.selectedItemsRole}</span>}

                            </div>
                        </div>
                        )}
                        {/* {userTypeCheck === "USER" && (
                        <div className="col-lg-12 col-12">
                            <div className="form-group">
                                <label>Role</label>
                                <ul>
                                {userRole.map((item, index) => (
                                    <li key={index}>{item.name} <sub>{item.description}</sub></li>
                                ))}
                                </ul>
                                <span></span>

                            </div>
                        </div>
                        )} */}
                        <div className="col-lg-6 col-12">
                            <div className="form-group d-flex items-center gap-5">
                                <label className="mb-0">Enabled</label>
                                <label className="switch">
                                    <input 
                                    type="checkbox" 
                                    checked={isCheckedEnable} 
                                    onChange={handleChangeEnableToggle} 
                                    />
                                    <span className="slider"></span>
                                </label>
                                <p>Status: {isCheckedEnable ? 'ON' : 'OFF'}</p>                     
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-group d-flex items-center gap-5">
                                <label className="mb-0">2FA</label>
                                <label className="switch">
                                    <input 
                                    type="checkbox" 
                                    checked={isChecked2FA} 
                                    onChange={handleChange2FAToggle} 
                                    />
                                    <span className="slider"></span>
                                </label>
                                <p>Status: {isChecked2FA ? 'ON' : 'OFF'}</p>
                            </div>
                        </div>
                        
                        <div className="col-lg-2 col-6">
                            <button onClick={handleSubmit} className="btn btn-primary submit-btn">Submit</button>
                        </div>
                        <div className="col-lg-2 col-6">
                            <button onClick={handleCancel} className="btn btn-primary cancel-btn">Cancel</button>
                        </div>
                    </form>
                </div>{/* /.container-fluid */}
            </section>
        </>
    );
}
  
export default AddUser;